export default "__VITE_ASSET__DZ9CToDE__"